export default __webpack_public_path__ + "static/media/prepare-icon.5ea0f7cc.svg";